import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Dropdown from '../Dropdown';
import Searchbar from '../Searchbar';
import * as styles from './SearchAndSelect.scss';

/**
 * Reusable SearchAndSelect Component (Combo Search/Dropdown List)
 * @function SearchAndSelect
 * @param {Object} props
 * @return {ReactElement}
 */
const SearchAndSelect = ({ className, dropdownProps, searchbarProps, style }) => {
  /**
   * SearchAndSelect Will Pass Down `dropdownProps` Object Directly to <Dropdown />
   * SearchAndSelect Will Pass Down `searchbarProps` Object Directly to <Searchbar />
   * @see ../Dropdown.jsx for List of Available Props
   * @see ../Searchbar.jsx for List of Available Props
   */
  return (
    <div className={classNames(styles.searchAndSelect, className)} style={style}>
      <Dropdown
        {...dropdownProps}
        className={classNames(styles.dropdown, dropdownProps.className)}
        buttonClassName={classNames(styles.dropdownButton, dropdownProps.buttonClassName)}
        listClassName={classNames(styles.dropdownList, dropdownProps.listClassName)} />
      <Searchbar
        {...searchbarProps}
        className={classNames(styles.searchbar, searchbarProps.className)}
        inputClassName={classNames(styles.searchbarInput, searchbarProps.inputClassName)} />
    </div>
  );
};

SearchAndSelect.propTypes = {
  dropdownProps: PropTypes.objectOf(
    PropTypes.any,
  ).isRequired,
  searchbarProps: PropTypes.objectOf(
    PropTypes.any,
  ).isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default SearchAndSelect;
